import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { storage } from '../../config/fbConfig';
const marketingRef = React.createRef();
const termsRef = React.createRef();
const countryCodeRef = React.createRef();

function EditCompany(props) {
  const [companyId, setCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [uploadedCompanyLogo, setUploadedCompanyLogo] = useState(false);
  const [companyLogoUrl, setCompanyLogoUrl] = useState('');
  const [circleLogo, setCircleLogo] = useState('');
  const [uploadedCircleLogo, setUploadedCircleLogo] = useState(false);
  const [circleLogoUrl, setCircleLogoUrl] = useState('');
  const [rewardImage, setRewardImage] = useState('');
  const [uploadedRewardImage, setUploadedRewardImage] = useState(false);
  const [rewardImageUrl, setRewardImageUrl] = useState('');
  const [ngcVendorCode, setNgcVendorCode] = useState('');
  const [denominations, setDenominations] = useState('');
  const [marketingMessage, setMarketingMessage] = useState('');
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [disableRedemption, setDisableRedemption] = useState(false);
  const [pynCardOff, setPynCardOff] = useState(false);
  const [redirectToCompanies, setRedirecToCompanies] = useState(false);
  const [companyLoaded, setCompanyLoaded] = useState(false);
  const [safetyPynMessage, setSafetyPynMessage] = useState('');
  const { firestore, auth, company } = props;

  const initLoading = () => {
    M.AutoInit();
    M.updateTextFields();
    if (marketingRef.current) {
      M.textareaAutoResize(marketingRef.current);
    }
    if (termsRef.current) {
      M.textareaAutoResize(termsRef.current);
    }
    if (countryCodeRef.current) {
      M.FormSelect.init(countryCodeRef.current);
    }
  };

  useEffect(initLoading, [companyLoaded]);

  const getRedeemRules = (denominations) => {
    const points = [];
    const pyns = [];

    for (var index in denominations) {
      const denomination = denominations[index];

      const keyPoint = (denomination * 100).toString();
      const point = {};
      point[keyPoint] = denomination;
      points.push(point);

      const keyPyn = (denomination * 5).toString();
      const pyn = {};
      pyn[keyPyn] = denomination;
      pyns.push(pyn);
    }

    const redeemRules = {
      point: points,
      pyn: pyns,
    };

    return redeemRules;
  };

  const cleanDenominations = (denominations) => {
    return denominations.replace(/\s/g, '');
  };

  const genString = (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const uploadImage = (folder, file, newImageurl) => {
    const newFileName = genString(5) + file.name;
    const uploadTask = storage.ref(`/${folder}/${newFileName}`).put(file);

    uploadTask.on(
      'state_changed',
      (snapShot) => {
        console.log(snapShot);
      },
      (err) => {
        console.error(err);
      },
      () => {
        storage
          .ref(folder)
          .child(newFileName)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            console.log(fireBaseUrl);
            newImageurl(fireBaseUrl);
          });
      },
    );
  };

  const validateCompany = () => {
    //TODO: implement it.
    return true;
  };

  const updateCompany = () => {
    const den = cleanDenominations(denominations);
    const denArray = den.split(',');

    const geoFenceColSetTL = company.geoFenceColSetTL ? company.geoFenceColSetTL : false;
    const createdAt = company.createdAt ? company.createdAt : firestore.FieldValue.serverTimestamp();

    const newCompany = {
      updatedAt: firestore.FieldValue.serverTimestamp(),
      createdAt: createdAt,
      geoFenceColSetTL: geoFenceColSetTL,
      companyName: companyName,
      countryCode: countryCode,
      ngcVendorCode: ngcVendorCode,
      redeemRules: getRedeemRules(denArray),
      denominations: den,
      marketing: marketingMessage,
      termsAndConditions: termsAndConditions,
      disableRedemption: disableRedemption,
      pynCardOff: pynCardOff,
      safetyPynMessage: safetyPynMessage,
    };

    if (!validateCompany(newCompany)) {
      alert('Company no valid');
      return;
    }

    firestore
      .collection('companies')
      .doc(companyId)
      .update(newCompany)
      .then(() => {
        setRedirecToCompanies(true);

        if (rewardImage) {
          uploadImage('banners', rewardImage, (imageUrl) => {
            setRewardImageUrl(imageUrl);
            firestore.collection('companies').doc(companyId).update({ bannerUrl: imageUrl });
            setUploadedRewardImage(true);
          });
        } else {
          setUploadedRewardImage(true);
        }

        if (companyLogo) {
          uploadImage('iconCompanies', companyLogo, (imageUrl) => {
            setCompanyLogoUrl(imageUrl);
            firestore.collection('companies').doc(companyId).update({ iconUrl: imageUrl });
            setUploadedCompanyLogo(true);
          });
        } else {
          setUploadedCompanyLogo(true);
        }

        if (circleLogo) {
          uploadImage('circleIconCompanies', circleLogo, (imageUrl) => {
            setCircleLogoUrl(imageUrl);
            firestore.collection('companies').doc(companyId).update({ circleIconUrl: imageUrl });
            setUploadedCircleLogo(true);
          });
        } else {
          setUploadedCircleLogo(true);
        }
      })
      .catch((error) => console.error(error));
  };

  if (!auth.uid) return <Redirect to="/signin"/>;
  if (redirectToCompanies && uploadedCompanyLogo && uploadedRewardImage && uploadedCircleLogo) return <Redirect to="/companies"/>;

  if (!companyLoaded && company) {
    setCompanyId(company.uid);
    setCompanyName(company.companyName);
    setCountryCode(company.countryCode);
    setNgcVendorCode(company.ngcVendorCode || '');
    setDenominations(company.denominations || '');
    setMarketingMessage(company.marketing || '');
    setTermsAndConditions(company.termsAndConditions || '');
    setPynCardOff(company.pynCardOff || false);
    setDisableRedemption(company.disableRedemption || false);
    setCompanyLogoUrl(company.iconUrl);
    setCircleLogoUrl(company.circleIconUrl || '');
    setRewardImageUrl(company.bannerUrl);
    setSafetyPynMessage(company.safetyPynMessage || '');
    setCompanyLoaded(true);
    return <div></div>;
  }

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <div className="col s4">
                <h4>Edit Company</h4>
                <small>{companyId}</small>
              </div>
              <div className="col s4">
                <img src={companyLogoUrl} alt="" className="company-logo"/>
                <br/>
                <small>Company Logo</small>
              </div>
              <div className="col s4">
                <img src={circleLogoUrl} alt="" className="circle-icon-logo"/>
                <br/>
                <small>Circle Company Logo</small>
              </div>
              <div className="col s4">
                <img src={rewardImageUrl} alt="" className="reward-image"/>
                <br/>
                <small>Reward Image</small>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input id="company_name" type="text" className="validate" name="companyName" value={companyName}
                       onChange={(e) => setCompanyName(e.target.value)}/>
                <label htmlFor="company_name">Company Name</label>
              </div>
              <div className="col s12">
                <div className="file-field input-field ">
                  <div className="btn">
                    <span>Company Logo</span>
                    <input type="file" onChange={(e) => setCompanyLogo(e.target.files[0])}/>
                  </div>
                  <div className="file-path-wrapper">
                    <input className="file-path validate" type="text"/>
                  </div>
                </div>
              </div>
              <div className="col s12">
                <div className="file-field input-field ">
                  <div className="btn">
                    <span>Circle Company Logo</span>
                    <input type="file" onChange={(e) => setCircleLogo(e.target.files[0])}/>
                  </div>
                  <div className="file-path-wrapper">
                    <input className="file-path validate" type="text"/>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <select ref={countryCodeRef} className="icons" value={countryCode}
                        onChange={(e) => setCountryCode(e.target.value)}>
                  <option value="" disabled>
                    Select your Country
                  </option>
                  <option data-icon="images/ca.svg" value="CA">
                    Canada
                  </option>
                  <option data-icon="images/us.svg" value="US">
                    United States
                  </option>
                  <option data-icon="images/bo.svg" value="BO">
                    Bolivia
                  </option>
                </select>
                <label>Country</label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input id="ngc_vendor_code" type="text" className="validate" name="ngcVendorcode" value={ngcVendorCode}
                       onChange={(e) => setNgcVendorCode(e.target.value)}/>
                <label htmlFor="ngc_vendor_code">NGC Vendor Code</label>
              </div>
              <div className="input-field col s12">
                <input id="denominations" type="text" className="validate" name="denominations" value={denominations}
                       onChange={(e) => setDenominations(e.target.value)}/>
                <label htmlFor="denominations">Denominations (ex: 2,5,10)</label>
              </div>
              <div className="col s12">
                <div className="file-field input-field ">
                  <div className="btn">
                    <span>Reward Card Image</span>
                    <input type="file" onChange={(e) => setRewardImage(e.target.files[0])}/>
                  </div>
                  <div className="file-path-wrapper">
                    <input className="file-path validate" type="text"/>
                  </div>
                </div>
              </div>
              <div className="input-field col s12">
                <textarea ref={marketingRef} id="taMarketingMessage" className="materialize-textarea"
                          name="marketingMessage" value={marketingMessage}
                          onChange={(e) => setMarketingMessage(e.target.value)}></textarea>
                <label htmlFor="taMarketingMessage">Marketing Message</label>
              </div>
              <div className="input-field col s12">
                <textarea ref={termsRef} id="taTermsAndConditions" className="materialize-textarea"
                          name="termsAndConditions" value={termsAndConditions}
                          onChange={(e) => setTermsAndConditions(e.target.value)}></textarea>
                <label htmlFor="taTermsAndConditions">Terms and Conditions</label>
              </div>
              <div className="input-field col s12">
                <textarea id="safetyPynMsg" className="materialize-textarea"
                          value={safetyPynMessage}
                          onChange={(e) => setSafetyPynMessage(e.target.value)}></textarea>
                <label htmlFor="safetyPynMsg">Safety Pyn Message</label>
              </div>
            </div>
            <div className="row">
              <div className="col s6">
                <label>Disable Redemption</label>
                <div className="switch">
                  <label>
                    <input type="checkbox" value={disableRedemption} checked={disableRedemption === true}
                           onChange={(e) => setDisableRedemption(e.target.checked)}/>
                    <span className="lever"></span>
                  </label>
                </div>
              </div>
              <div className="col s6">
                <label>Pyn Card Off</label>
                <div className="switch">
                  <label>
                    <input type="checkbox" value={pynCardOff} checked={pynCardOff === true}
                           onChange={(e) => setPynCardOff(e.target.checked)}/>
                    <span className="lever"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="card-action">
            <a href="#update" className="waves-effect waves-light btn btn-large" onClick={updateCompany}>
              UPDATE
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const companyId = ownProps.match.params.id;
  const company = state.firestore.data['currentCompany'];
  return {
    id: companyId,
    company: company ? company[companyId] : null,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => [{ collection: 'companies', where: ['uid', '==', props.id], storeAs: 'currentCompany' }]),
)(EditCompany);
